/** Enum for supported video types */ export var SupportedVideoTypes;
(function(SupportedVideoTypes) {
    SupportedVideoTypes["Stream"] = "stream-video";
    SupportedVideoTypes["Youtube"] = "yt-video";
    SupportedVideoTypes["Vimeo"] = "vimeo-video";
    SupportedVideoTypes["DailyMotion"] = "dm-video";
    SupportedVideoTypes["Facebook"] = "fb-video";
})(SupportedVideoTypes || (SupportedVideoTypes = {}));
